import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import { useMutation, useQuery } from '@tanstack/react-query';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, useDispatch } from 'react-redux';
import DeletePECRPopup from '../../pages/ListTableAndTrackingFIle/DeletePECRPopup';
import { sendEmail } from '../../queries/emailQueries';
import {
  cancelPecr,
  createGetOverviewOptions,
  createGetOverviewStepsOptions,
} from '../../queries/overviewQueries';
import { errorNotification } from '../../reducers/handle-api-status/slice';
import { summaryDeleteIcon } from '../../styles';
import { validateInputFields } from '../../utils';

function DeletePecr({ Container, pecrId, siteId, userInfo, disabled }) {
  const validationDefaultState = {
    DeleteComment: '',
    ManagerComments: '',
  };
  const [openDeletePECRModal, setOpenDeletePECRModal] = useState(false);
  const [openAddCommentModal, setOpenAddCommentModal] = useState(false);
  const [deletePECRComment, setDeletePECRComment] = useState('');
  const [deletePECRData, setDeletePECRData] = useState({});
  const [inputValidationMessage, setInputValidationMessage] = useState(
    validationDefaultState
  );
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { data, error } = useQuery(
    createGetOverviewStepsOptions({ pecrId: pecrId }, { enabled: !!pecrId })
  );

  const { data: overviewData, error: overviewError } = useQuery(
    createGetOverviewOptions({ pecrId: pecrId }, { enabled: !!pecrId })
  );

  const { mutate: cancelPecrForSite } = useMutation({
    mutationFn: cancelPecr,
    onSuccess: () => {
      onCancelClick();
    },
    onError: error => {
      console.error('Error cancelling PECR:', error);
      dispatch(
        errorNotification({
          hasErrorOccured: true,
          message: t('error_message'),
        })
      );
    },
  });

  const { mutate: sendCancelEmail } = useMutation({
    mutationFn: sendEmail,
    onError: error => {
      console.error('Error sending cancel email:', error);
      dispatch(
        errorNotification({
          hasErrorOccured: true,
          message: t('error_message'),
        })
      );
    },
  });
  if (error || overviewError) {
    console.error(
      'Error fetching overview steps data:',
      error || overviewError
    );
    dispatch(
      errorNotification({
        hasErrorOccured: true,
        message: t('error_message'),
      })
    );
  }

  let completedSteps = null;
  let cancelEmails = null;
  let creator = {};
  if (data && data.length > 0) {
    completedSteps = Object.groupBy(
      data,
      item => !['5', '7', '9', '14', null, ''].includes(item.ActualStatus)
    );
    cancelEmails = completedSteps[true]
      ? Array.from(
          new Set(
            completedSteps[true].map(item => item.Email).filter(email => email)
          )
        )
      : [];
    const creatorStep = data.find(item => item.Step === 'Creator');
    creator = creatorStep
      ? {
          UserName: creatorStep.UserName,
          SiteName: creatorStep.SiteName,
        }
      : { UserName: '-', SiteName: '-' };
  }

  const onNoClick = () => {
    setOpenDeletePECRModal(false);
  };

  const onYesClick = () => {
    setOpenAddCommentModal(true);
  };

  const onCancelClick = () => {
    onNoClick();
    setOpenAddCommentModal(false);
    setDeletePECRComment('');
    setDeletePECRData({});
    setInputValidationMessage(validationDefaultState);
  };

  function onAddCommentClick() {
    // if (deletePECRComment.trim() !== '') {
    cancelPecrForSite({
      pecrId: pecrId,
      siteId: siteId,
      comments: deletePECRComment,
      userID: userInfo.userID,
    });

    //   setIsDeletePECRdone(!isDeletePECRdone);
    cancelEmails &&
      overviewData &&
      cancelEmails.forEach(email => {
        sendCancelEmail({
          toAddress: email,
          fromAddress: 'PECR@carrier.com',
          Title: overviewData?.Title || '',
          creator: creator.UserName || '',
          creatorsite: creator.SiteName || '',
          PecrId: pecrId,
          loginUserEmail: userInfo.userEmail,
          type: 'assignEmail',
          toWhome: 'Cancel Email',
          Comments: deletePECRComment,
        });
      });
  }
  function handleDeletePECRComment(event) {
    const eventValue = event.target.value;
    setDeletePECRComment(eventValue);
    const ValidationMessage = validateInputFields(eventValue, t);
    setInputValidationMessage({
      ...inputValidationMessage,
      [event.target.name]: ValidationMessage,
    });
  }
  return (
    <>
      <Container>
        <DeleteForeverOutlinedIcon
          sx={{
            ...summaryDeleteIcon,
            cursor: disabled ? 'not-allowed' : 'pointer',
            opacity: disabled ? 0.5 : 1,
            pointerEvents: disabled ? 'none' : 'auto',
          }}
          onClick={() => {
            if (!disabled) {
              setOpenDeletePECRModal(true);
            }
          }}
        />
      </Container>
      <DeletePECRPopup
        onYesClick={onYesClick}
        onNoClick={onNoClick}
        onAddCommentClick={onAddCommentClick}
        onCancelClick={onCancelClick}
        handleCommentChange={handleDeletePECRComment}
        openDeletePECRModal={openDeletePECRModal}
        openAddComment={openAddCommentModal}
        deleteCommentValue={deletePECRComment}
        inputValidationMessage={inputValidationMessage.DeleteComment}
      />
    </>
  );
}

DeletePecr.propTypes = {
  Container: PropTypes.elementType.isRequired,
  pecrId: PropTypes.string.isRequired,
  siteId: PropTypes.string.isRequired,
  userInfo: PropTypes.shape({
    userID: PropTypes.string.isRequired,
    userEmail: PropTypes.string.isRequired,
  }).isRequired,
};
const mapStateToProps = (state = {}) => {
  return {
    userInfo: state.userInfo,
    errorInAPI: state.errorNotification,
  };
};
export default connect(mapStateToProps, null)(DeletePecr);
